export function shopifyRound(i: number, digits: number) {
    const pow = Math.pow(10, digits);

    return Math.floor(i * pow) / pow;
}